import { Paper } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const styles = theme => {
    return {
        root: {
            borderRadius: '4px',
        },
        squared: {
            borderRadius: 0,
        },
        outlined: {
            border: `1px solid ${theme.palette.border}`,
        },
    };
};

const useStyles = makeStyles()(styles);

const CustomPaper = props => {
    const { className, outlined, squared, children, ...rest } = props;
    const { classes, cx } = useStyles(undefined, {
        props,
    });
    const rootClassName = cx(
        {
            [classes.root]: true,
            [classes.squared]: squared,
            [classes.outlined]: outlined,
        },
        className
    );

    return (
        <Paper {...rest} className={rootClassName}>
            {children}
        </Paper>
    );
};

CustomPaper.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    elevation: PropTypes.number,
    outlined: PropTypes.bool,
    squared: PropTypes.bool,
};

CustomPaper.defaultProps = {
    squared: false,
    outlined: true,
    elevation: 1,
};

export default CustomPaper;
